import { useMemo } from 'react';

import { atom } from 'recoil';
import { useRecoilState } from 'recoil';

import { AggregateOn } from 'components/enums';

export const aggregateAtom = atom<AggregateOn>({
  key: 'aggregate',
  default: AggregateOn.MONTH
});

export const yearAtom = atom<number>({
  key: 'year',
  default: new Date().getFullYear()
});

export const quarterAtom = atom<number>({
  key: 'quarter',
  default: 1
});

const useYearQuarterNavigation = () => {
  const [aggregate, setAggregate] = useRecoilState(aggregateAtom);
  const [year, setYear] = useRecoilState(yearAtom);
  const [quarter, setQuarter] = useRecoilState(quarterAtom);

  const isViewPerWeek = aggregate === AggregateOn.WEEK;

  const onNavigateYear = (direction: 'prev' | 'next') => {
    if (direction === 'prev') {
      setYear(year - 1);
    } else {
      setYear(year + 1);
    }
  };

  const onNavigateQuarter = (direction: 'prev' | 'next') => {
    if (direction === 'prev') {
      if (quarter === 1) {
        setQuarter(4);
        setYear(year - 1);
        return;
      }
      setQuarter(quarter - 1);
    } else {
      if (quarter === 4) {
        setQuarter(1);
        setYear(year + 1);
        return;
      }
      setQuarter(quarter + 1);
    }
  };

  const onNavigate = isViewPerWeek ? onNavigateQuarter : onNavigateYear;

  const toggleView = () => {
    isViewPerWeek
      ? setAggregate(AggregateOn.MONTH)
      : setAggregate(AggregateOn.WEEK);
  };

  const interval = useMemo(
    () =>
      isViewPerWeek
        ? [
            { start: 0, end: 13 },
            { start: 13, end: 26 },
            { start: 26, end: 39 },
            { start: 39, end: null }
          ][quarter - 1]
        : { start: 0, end: 12 },
    [isViewPerWeek, quarter]
  );

  return {
    aggregate,
    year,
    quarter,
    isViewPerWeek,
    toggleView,
    onNavigate,
    onNavigateYear,
    onNavigateQuarter,
    interval
  };
};

export default useYearQuarterNavigation;
